import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './manage-purchase-navbar.component'

let module = angular.module('managePurchaseNavbar', [
  uiRouter
])

.component('managePurchaseNavbar', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/common/manage-purchase-navbar/index.js